export const initializeCalEmbed = () => {
  if (document.getElementById('cal-embed-script')) {
    return
  }

  const script = document.createElement('script')
  script.id = 'cal-embed-script'
  script.type = 'text/javascript'
  script.innerHTML = `
      (function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if(typeof namespace === "string"){cal.ns[namespace] = cal.ns[namespace] || api;p(cal.ns[namespace], ar);p(cal, ["initNamespace", namespace]);} else p(cal, ar); return;} p(cal, ar); }; })(window, "https://app.cal.eu/embed/embed.js", "init");
Cal("init", "priority-support", {origin:"https://app.cal.eu"});
Cal.ns["priority-support"]("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
    `

  document.head.appendChild(script)
}

export const openPrioritySupportCalendar = () => {
  initializeCalEmbed()

  setTimeout(() => {
    const button = document.createElement('button')
    button.setAttribute('data-cal-link', 'kourosh-ghaffari-y47u7x/priority-support')
    button.setAttribute('data-cal-namespace', 'priority-support')
    button.setAttribute('data-cal-config', '{"layout":"month_view","useSlotsViewOnSmallScreen":"true"}')
    document.body.appendChild(button)
    try {
      button.click()
    } finally {
      if (button.parentNode) {
        button.parentNode.removeChild(button)
      }
    }
  }, 1000)
}

export const openEnterpriseEnquiryCalendar = () => {
  initializeCalEmbed()

  setTimeout(() => {
    const button = document.createElement('button')
    button.setAttribute('data-cal-link', 'kourosh-ghaffari-y47u7x/enterprise-enquiry')
    button.setAttribute('data-cal-namespace', 'priority-support')
    button.setAttribute('data-cal-config', '{"layout":"month_view","useSlotsViewOnSmallScreen":"true"}')
    document.body.appendChild(button)
    try {
      button.click()
    } finally {
      if (button.parentNode) {
        button.parentNode.removeChild(button)
      }
    }
  }, 1000)
}
